export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 0_00.e660b583.jpg";